import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import CloseVirtualCardContent from 'src/app/CloseVirtualCardContent/CloseVirtualCardContent'
import {
  selectVirtualCard,
  selectVirtualCardIdFromRoute,
} from 'src/app/CloseVirtualCardContent/redux/closeVirtualCardContent.selectors'
import { useFlyoutDispatch } from 'src/hooks'
import { connectedReplace } from 'src/navigation/Lnk'
import { closeVirtualCardUrl } from 'src/navigation/urls'
import {
  getVirtualCard,
  getVirtualCardPermissions,
} from 'src/redux/actions/data/virtualCards.actions'

const CloseBillPayCard: React.FC = (): React.ReactElement => {
  const dispatch = useFlyoutDispatch()
  const virtualCardId = useSelector(selectVirtualCardIdFromRoute)
  const virtualCard = useSelector(selectVirtualCard)

  useEffect((): void => {
    dispatch(getVirtualCard(virtualCardId))
    dispatch(getVirtualCardPermissions(virtualCardId))
  }, [virtualCard?.status, virtualCardId])

  useEffect(() => {
    if (virtualCard === undefined) return

    if (!virtualCard.isBillPay) {
      // user is trying to access a regular card, redirect to the virtual card url
      dispatch(connectedReplace(closeVirtualCardUrl(virtualCardId)))
    }
  }, [virtualCard])

  return (
    <CloseVirtualCardContent
      virtualCardId={virtualCardId}
      virtualCard={virtualCard}
    />
  )
}

export default CloseBillPayCard
